export const whatsappLink = 'https://web.whatsapp.com/send?phone=5511955943059&text=Quero%20comprar%20SMS';
